"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_DESCRIPTION_MAX_CHARS = exports.DEFAULT_CATEGORY_LABEL = void 0;
exports.parseProductDimensions = parseProductDimensions;
exports.parseProductMetadata = parseProductMetadata;
function parseProductDimensions(raw) {
    if (!raw)
        return null;
    if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (!trimmed)
            return null;
        const numbers = trimmed.match(/\d+(?:[.,]\d+)?/g)?.map((n) => parseFloat(n.replace(',', '.')));
        if (numbers && numbers.length > 0) {
            return {
                length: numbers[0] ?? null,
                width: numbers[1] ?? null,
                height: numbers[2] ?? null,
                weight: numbers[3] ?? null,
                volume: null,
            };
        }
        return null;
    }
    if (typeof raw !== 'object' || Array.isArray(raw))
        return null;
    const obj = raw;
    const parseNum = (v) => {
        if (typeof v === 'number' && !isNaN(v))
            return v;
        if (typeof v === 'string') {
            const parsed = parseFloat(v.replace(',', '.'));
            return !isNaN(parsed) ? parsed : null;
        }
        return null;
    };
    return {
        length: parseNum(obj.length ?? obj.l),
        width: parseNum(obj.width ?? obj.w),
        height: parseNum(obj.height ?? obj.h),
        weight: parseNum(obj.weight ?? obj.wt),
        volume: parseNum(obj.volume ?? obj.vol),
    };
}
function parseProductMetadata(raw) {
    if (!raw || typeof raw !== 'object')
        return null;
    const obj = raw;
    return {
        ...obj,
        dimensions: parseProductDimensions(obj.dimensions),
        material: typeof obj.material === 'string' ? obj.material : null,
        finish: typeof obj.finish === 'string' ? obj.finish : null,
        careInstructions: typeof obj.careInstructions === 'string' ? obj.careInstructions : null,
        warranty: typeof obj.warranty === 'string' ? obj.warranty : null,
    };
}
/** Default category name when no category is assigned. */
exports.DEFAULT_CATEGORY_LABEL = 'Mobilier';
/** Maximum characters for short description truncation in quick-view components. */
exports.SHORT_DESCRIPTION_MAX_CHARS = 160;
//# sourceMappingURL=metadata.js.map